import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import classnames from "classnames";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import PeriodConverter from "@state/common/PeriodConverter";

export const MainMenuSelectorPeriod = observer(
	function MainMenuSelectorPeriod(props: { store: PrematchOfferMenuStore }) {
		const t = useTranslation().t;

		return (
			<li className="nav--secondary__item nav--sports__item">
				<a
					className={classnames(`nav--secondary__link`, {
						"is-expanded":
							props.store.periodSubMenu.isPeriodMenuExpanded,
					})}
					onClick={() => props.store.periodSubMenu.togglePeriodMenu()}
				>
					<i
						className={`nav--secondary__icon u-icon u-icon--lrg u-icon--${PeriodConverter.IsDateString(props.store.periodSubMenu.selectedPeriod.period) ? "previous" : props.store.periodSubMenu.selectedPeriod.period}`}
					/>
					<div className="nav--secondary__title">
						{t(props.store.periodSubMenu.selectedPeriod.name)}
					</div>
				</a>
			</li>
		);
	}
);
